import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * useInternalLinkNav — gestionnaire de clic délégué pour naviguer EN INTERNE
 * (SPA, sans rechargement) sur les liens `<a href="/…">` rendus par les blocs
 * CMS (Carte, Bouton…). À poser en `onClick` sur le conteneur qui entoure le
 * contenu CMS (accueil Puck, page /page/:slug).
 *
 * - Ne touche PAS les liens externes (`target="_blank"`, http(s)…).
 * - Respecte cmd/ctrl/shift/clic-milieu (ouverture volontaire d'un onglet).
 * - Portée limitée au conteneur CMS → n'interfère pas avec les <Link> React
 *   Router des autres écrans.
 */
export default function useInternalLinkNav() {
  const navigate = useNavigate();
  return useCallback((e) => {
    const a = e.target?.closest?.('a[href]');
    if (!a) return;
    if (a.target === '_blank' || e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    const href = a.getAttribute('href') || '';
    if (href.startsWith('/') && !href.startsWith('//')) {
      e.preventDefault();
      navigate(href);
    }
  }, [navigate]);
}
